<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="720px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :validate-on-rule-change="false"
      :model="ruleForm"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="人员姓名："
        prop="name">
        <el-input
          v-model="ruleForm.name"
          show-word-limit
          :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item
        label="人员头像："
        prop="headPicture">
        <upload-with-crop
          v-model="ruleForm.headPicture"
          :cropper="true"
          :isLt2M="500"
          :limit="1"
          :fixedNumber="[1,1]"
          :autoCropWidth="120"
          :autoCropHeight="120"></upload-with-crop>
      </el-form-item>
      <el-form-item
        label="联系电话："
        prop="phone">
        <el-input
          v-model="ruleForm.phone"
          show-word-limit
          :maxlength="11"></el-input>
      </el-form-item>
      <el-form-item
        label="人员职称："
        prop="work">
        <expert-career-select v-model="ruleForm.work" />
      </el-form-item>
      <el-form-item
        label="排序值："
        prop="sortNumber">
        <el-input-number
          v-model="ruleForm.sortNumber"
          :precision="0"
          :min="1"
          :max="1000"></el-input-number>
      </el-form-item>
      <el-form-item
        label="人员简介："
        prop="briefIntroduction">
        <el-input
          v-model="ruleForm.briefIntroduction"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 4}"
          show-word-limit
          :maxlength="150"></el-input>
      </el-form-item>
      <el-form-item
        label="图文介绍："
        prop="detailedImages">
        <desc-images
          v-model="ruleForm.detailedImages"
          edit></desc-images>
      </el-form-item>
      <el-form-item
        label="是否上架："
        prop="status">
        <el-switch
          v-model="ruleForm.status"
          :active-value="1"
          :inactive-value="0">
        </el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DescImages from '../../../components/public/desc-images.vue'
import UploadWithCrop from '../../../components/public/upload-with-crop.vue'
import Expert from '@/service/expert'
import ExpertCareerSelect from './expert-career-select.vue'
export default {
  name: 'EditExpertModal',
  components: { DescImages, UploadWithCrop, ExpertCareerSelect },
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: { id: null, name: '', work: '', phone: '', headPicture: [], briefIntroduction: '', detailedImages: [], sortNumber: 1, status: 1 },
      rules: {
        name: [
          { required: true, message: '请输入人员姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'change' }
        ],
        work: [
          { required: true, message: '请选择职业', trigger: 'change' }
        ],
        briefIntroduction: [
          { required: true, message: '请输入人员简介', trigger: 'blur' }
        ],
        headPicture: [
          { required: true, message: '请上传人员头像', trigger: 'change' }
        ],
        detailedImages: [
          { required: true, message: '请上传图文介绍', trigger: 'change' }
        ],
        sortNumber: [
          { required: true, message: '请输入排序值', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择是否上架', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    title({ ruleForm }) {
      return (ruleForm.id ? '编辑' : '新增') + '人员'
    }
  },
  methods: {
    handleClosed() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { headPicture, detailedImages, id } = this.ruleForm
          const dispatch = id ? 'updateexpert' : 'addexpert'
          Expert[dispatch]({
            ...this.ruleForm,
            headPicture: this.$stringfyImage(headPicture),
            detailedImages: this.$stringfyImage(detailedImages)
          })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.visible = false
                this.$message.success('提交成功')
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    init(options = {}) {
      const { headPicture, detailedImages } = options
      this.ruleForm = {
        ...this.ruleForm,
        ...options,
        headPicture: this.$splitImage(headPicture),
        detailedImages: this.$splitImage(detailedImages)
      }
      this.visible = true
    }
  }
}
</script>
